import React, { Component } from "react"
import { Route, Switch, Redirect } from "react-router-dom"
import Layout from "app/core/Layout"
import PgsApp from './pgs'
import PgdApp from './pgd'
import AzfApp from './azf'
import EcsApp from './ecs'
import ArrayPgt from './arrayPgt'
import Preview from './preview'
import Research from './research'
import { inject, observer } from "mobx-react"
import "app/Index.scss"
import "app/styles/sass/modal.scss"
import "app/styles/sass/base.scss"
import "app/styles/less/ant-theme-vars.less"
import { setCurrentApp } from '../api/localTools'
import NoticeInfoModal from '../components/normal/NoticeInfoModal'

class MainPanel extends Layout {
  renderContent() {
    return <div>{this.props.children}</div>
  }
}

@inject("auth", "entrance") @observer
export default class Main extends Component {
  constructor(props) {
    super(props)
    this.state = {
      noticeInfoShowed: false,
    }
  }

  showModal = () => {
    this.setState({
      noticeInfoShowed: true
    })
  }

  closeModal = () => {
    this.setState({
      noticeInfoShowed: false
    })
  }

  componentDidMount() {
    const { auth } = this.props
    auth.needLoadApps && auth.getApps().then(this.setCurrentAppFromPath)
    auth.getPushAuth()
    auth.getNotices()
      .then(res => {
        if (res.length > 0 && res[0].state === 0) {
          this.setState({
            noticeInfoShowed: true
          })
        }
      })
  }

  setCurrentAppFromPath = () => {
    const { apps } = this.props.auth

    apps.forEach(app => {
      if (window.location.pathname.includes(`/jab/main/${app}`)) {
        setCurrentApp(app)
      }
    })
  }

  render() {
    const { match, auth: { firstNotice } } = this.props
    const { noticeInfoShowed } = this.state

    return (
      <MainPanel>
        <Switch>
          <Route path={`${match.url}/pgs`} component={PgsApp} />
          <Route path={`${match.url}/pgd`} component={PgdApp} />
          <Route path={`${match.url}/azf`} component={AzfApp} />
          <Route path={`${match.url}/ecs`} component={EcsApp} />
          <Route path={`${match.url}/array-pgt`} component={ArrayPgt} />
          <Route path={`${match.url}/preview`} component={Preview} />
          <Route path={`${match.url}/research`} component={Research} />
          <Redirect from='*' to={`${match.url}/pgs`} />
        </Switch>
        {noticeInfoShowed && (
          <NoticeInfoModal
            onceShow={true}
            selectedNotice={firstNotice}
            onClose={() => this.closeModal('noticeInfoShowed')}
          />
        )}
      </MainPanel>
    )
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/Main.js